import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormData } from '../aeo-approval/aeo-approval.component';


@Component({
  selector: 'cargoes-action-comments-dynamic',
  templateUrl: './action-comments-dynamic.component.html',
  styles: [],
})
export class ActionCommentsDynamicComponent implements OnInit{
  approvalStatusList:any[] = [];
  @Input() public defaultFormData!:string;
  @Output() public submitedFormData = new EventEmitter<FormData>();
  public moreInfoForm!: FormGroup;
  public formData = { variables: {
    action:{},
    comments:{}
  } };
  public load = false;
  // eslint-disable-next-line no-empty-function
  constructor(private formBuilder: FormBuilder) { }

  ngOnInit():void {

    if(typeof this.defaultFormData === 'object' ){
      this.onLoad(this.defaultFormData);
      this.load = true;
    }
  }

  onLoad(data:any):void {
    this.moreInfoForm = this.formBuilder.group({
      approvalStatus: ['', [Validators.required]],
      comments: [''],
    });
    // console.log('checking rdm',data.rdmData)
    const keys = Object.keys(data.rdmData);
    keys.forEach((key) => {
      if (key.indexOf('approval') >= 0) {
        this.approvalStatusList = data.rdmData[key];
      }
    });
  }

  onSubmit():void {

    for (const i in this.moreInfoForm.controls) {
      if(i in this.moreInfoForm.controls){
        this.moreInfoForm.controls[i].markAsDirty();
        this.moreInfoForm.controls[i].updateValueAndValidity();
      }
    }

    if (this.moreInfoForm.value.approvalStatus.length > 0) {
      this.formData.variables['action'] = { 'value': this.moreInfoForm.value.approvalStatus };
    }
    if ((this.moreInfoForm.value.comments.length > 0)) {

      this.formData.variables['comments'] = { 'value': this.moreInfoForm.value.comments };
    }

    if (this.moreInfoForm.valid) {
      this.submitedFormData.emit(this.formData);
    }

  }

}
